<template>
  <div class="my-2">
   
    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>
      </v-tabs>
    </v-toolbar>
    <div v-if="displayContents('subscribers')">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-btn
          round
          color="primary"
          class="white--text"
          @click="addSubscriptionModal()"
        >Add Subscription</v-btn>
      </v-toolbar>
      <v-data-table :items="customers" :headers="subscriberHeaders">
        <template v-slot:items="props">
          <td>
            <v-layout justify-center align-center>
              <v-icon @click="editSubscription(props.item)">edit</v-icon>
            </v-layout>
          </td>
          <td class="text-xs-center">{{props.item.name}}</td>
          <td class="text-xs-center">{{props.item.gluePlan.name}}</td>
          <td class="text-xs-center">{{formatDate(props.item.startDate)}}</td>
          <td class="text-xs-center">{{formatDate(props.item.endDate)}}</td>
          <td class="text-xs-center" :key="key">
              <v-btn round color="light-green" class="white--text" v-if="props.item.isActive" @click="updateStatus(props.item)">Active</v-btn>
              <v-btn round color="red" class="white--text" v-else @click="updateStatus(props.item)">Inactive</v-btn>
            </td>
        </template>
      </v-data-table>
    </div>
    <div v-if="displayContents('plans')">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-btn round color="primary" class="white--text" @click="addPlan()">Add Plan</v-btn>
      </v-toolbar>
      <v-data-table :items="plans" :headers="planHeaders">
        <template v-slot:items="props">
          <td>
            <v-layout justify-center align-center>
              <v-icon @click="editPlan(props.item)">edit</v-icon>
            </v-layout>
          </td>
          <td class="text-xs-center">{{props.item.name}}</td>
          <td class="text-xs-center">
              <v-chip v-if="props.item.isFlat" color="blue" class="white--text">Flat</v-chip>
               <v-chip v-else-if="props.item.isBracket" color="light-green" class="white--text">Bracket</v-chip>
               <v-chip v-else color="light-green" class="white--text">Per Unit</v-chip>
              </td>
          <td class="text-xs-center" :key="key">
              <v-btn round color="light-green" class="white--text" v-if="props.item.isActive" @click="updatePlanStatus(props.item)">Active</v-btn>
              <v-btn round color="red" class="white--text" v-else @click="updatePlanStatus(props.item)">Inactive</v-btn>
            </td>
        </template>
      </v-data-table>
    </div>
    <div v-if="displayContents('billing')">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-btn round color="primary" class="white--text" @click="getBillingData()">Get Billing</v-btn>
        <v-btn round color="primary" class="white--text" v-if="xeroUrl" :href="xeroUrl">Connect to Xero</v-btn>
        <v-btn v-if="selectedBilling.length>0&&selectedOrganisation" round color="primary" class="white--text" @click="approveBilling()">Approve Billing</v-btn>
      </v-toolbar>
      <v-data-table select-all :items="billableAmounts" :headers="billingHeaders" v-model="selectedBilling" item-key="organisationId">
        <template v-slot:items="props">
           <td>
            <v-checkbox id="checkBoxId" v-model="props.selected" primary hide-details></v-checkbox>
          </td>
          <td class="text-xs-center">
            {{props.item.organisation.name}}
          </td>
          <td class="text-xs-center">
            {{props.item.plans.length}}
          </td>
          <td class="text-xs-center">
            {{props.item.total | currency}}
          </td>
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="addPlanModal" persistent width="750px">
        <v-card flat color="white">
        <v-toolbar flat color="primary">
          <h3 class="title white--text">{{item.modalType}} Plan</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="addPlanModal=false, item={}">X</v-btn>
        </v-toolbar>
        <v-card-text ma-1>
            <v-layout justify-center align-center wrap>
                <v-flex xs4 mx-1>
                    <v-text-field label="Name" v-model="item.name"></v-text-field>
                </v-flex>
                <v-flex xs4 mx-1>
                    <v-select :items="planTypes" label="Type" v-model="item.type"></v-select>
                </v-flex>
                 <v-flex xs4 mx-1>
                    <v-autocomplete :items="xeroAccounts" label="Xero Account" item-text="name" item-value="code" v-model="item.xeroAccountCode"></v-autocomplete>
                </v-flex>
                <v-flex xs4 mx-1>
                    <v-checkbox label="Flat Fee" v-model="item.isFlat"></v-checkbox>
                </v-flex>
                 <v-flex xs4 mx-1>
                    <v-checkbox label="Bracket Fee" v-model="item.isBracket"></v-checkbox>
                </v-flex>
                <v-flex xs4 mx-1 v-if="item.isFlat">
                    <v-text-field type="number" label="Flat Fee Amount" v-model="item.flatFee"></v-text-field>
                </v-flex>
                <v-flex xs4 mx-1 v-if="!item.isFlat&&!item.isBracket">
                    <v-text-field type="number" label="Price per Unit" v-model="item.pricePerUnit"></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout justify-center align-center wrap v-if="item.isBracket&&item.glueBrackets">
              <v-flex xs8>
                <h3 class="grey--text">Pricing Brackets:</h3>
              </v-flex>
              <v-flex xs8 mx-1 v-for="bracket in item.glueBrackets" :key="bracket.id">
                <v-layout justify-center align-center wrap>
                  <v-flex xs5>
                    <h3 class="grey--text font-weight-light">{{bracket.start}} - {{bracket.end}}</h3>
                  </v-flex>
                  <v-flex xs5>
                    <h3 class="grey--text font-weight-light">{{bracket.pricePerUnit | currency}}</h3>
                  </v-flex>
                  <v-flex xs2>
                    <v-layout justify-center wrap>
                        <v-icon>edit</v-icon>
                        <v-icon>delete</v-icon>
                    </v-layout>
                  </v-flex>

                </v-layout>
              </v-flex>
            </v-layout>

        </v-card-text>
        <v-card-actions>
            <v-layout justify-center align-center>
                <v-btn v-if="item.modalType == 'Add'" round color="primary" class="white--text" @click="createNewPlan(item)">Create</v-btn>
                <v-btn v-else round color="primary" class="white--text" @click="updatePlan(item)">Save</v-btn>
            </v-layout>
        </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="addSubscription" persistent width="750px">
      <v-card flat color="white">
        <v-toolbar flat color="primary">
          <h3 class="title white--text">{{item.modalType}} Subscription</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="addSubscription=false, item={}">X</v-btn>
        </v-toolbar>
        <v-card-text ma-1>
          <v-layout justify-center align-center wrap>
            <v-flex xs4 mx-1>
              <v-text-field label="Name" v-model="item.name"></v-text-field>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-autocomplete
                :items="allOrganisations"
                label="Organisation"
                item-text="name"
                item-value="id"
                v-model="item.organisationId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-autocomplete
                :items="xeroContacts"
                label="Xero Contact"
                item-text="name"
                item-value="contactID"
                v-model="item.xeroContactId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-autocomplete
                :items="plans"
                label="Plan"
                item-text="name"
                item-value="id"
                v-model="item.gluePlanId"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs4 mx-1>
              <v-menu :close-on-content-click="false">
                <v-text-field
                  id="addDateId"
                  :value="this.item.startDate"
                  slot="activator"
                  required
                  label="Start Date"
                  prepend-icon="date_range"
                ></v-text-field>
                <v-date-picker v-model="item.startDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-menu :close-on-content-click="false">
                <v-text-field
                  id="addDateId"
                  :value="this.item.endDate"
                  slot="activator"
                  required
                  label="End Date"
                  prepend-icon="date_range"
                ></v-text-field>
                <v-date-picker v-model="item.endDate"></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
            v-if="item.modalType=='Add'"
              round
              color="primary"
              class="white--text"
              @click="createSubscriberPlan(item)"
            >Create</v-btn>
            <v-btn
            v-if="item.modalType=='Edit'"
              round
              color="primary"
              class="white--text"
              @click="updateSubscriberPlan(item)"
            >Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="billingModal" persistent width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Invoice Settings</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat v-if="billingItem.invoiceStatus&&billingItem.lineAmountType&&billingItem.taxRate&&billingItem.dueDate&&billingItem.reference" @click="sendInvoices()">Send Invoice</v-btn>
          <v-btn flat color="white" @click="billingModal=false, billingItem={}, selectedBilling=[]">X</v-btn>
        </v-toolbar>
        <v-card-text ma-1>
          <v-layout justify-center align-center wrap>
            <v-flex xs3 mx-1>
              <v-select label="Invoice Status" :items="invoiceStatuses" v-model="billingItem.invoiceStatus"></v-select>
            </v-flex>
            <v-flex xs3 mx-1>
              <v-text-field label="Invoice reference" v-model="billingItem.reference"></v-text-field>
            </v-flex>
            <v-flex xs3 mx-1>
              <v-select label="Amount Tax Type" :items="lineAmountTypes" v-model="billingItem.lineAmountType"></v-select>
            </v-flex>
            <v-flex xs3 mx-1>
              <v-select label="Tax Rate" :items="xeroTaxRates" item-text="name" item-value="taxType" v-model="billingItem.taxRate"></v-select>
            </v-flex>
            <v-flex xs3 mx-1>
               <v-menu :close-on-content-click="false">
                <v-text-field
                  id="addDateId"
                  :value="this.billingItem.dueDate"
                  slot="activator"
                  required
                  label="Due Date"
                  prepend-icon="date_range"
                ></v-text-field>
                <v-date-picker v-model="billingItem.dueDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs10 mx-1>
              <h3 class="grey--text">Billing Breakdown:</h3>
            </v-flex>
            <v-flex xs8 mx-1 v-for="invoice in selectedBilling" :key="invoice.organisationId">
              <v-card color="white" class="text-xs-left">
                   <v-layout justify-center align-center wrap>
                <v-flex xs9 ma-1 class="text-xs-center">
                  <h3 class="title grey--text">{{invoice.organisation.name}}</h3>
                  <v-spacer></v-spacer>
                  <v-chip v-if="billingItem.invoiceStatus" color="blue" class="white--text">{{billingItem.invoiceStatus}}</v-chip>
                </v-flex>
                <!-- <v-flex xs12 mx-1>
                  <h3 class="grey--text" >Items:</h3>
                </v-flex> -->
                <v-flex xs12 mx-1 v-for="item in invoice.plans" :key="item.units">
                  <v-layout justify-center align-center wrap>
                    <v-flex xs4>
                      <h4 class="grey--text font-weight-light">{{item.name}}</h4>
                    </v-flex>
                    <v-flex xs2 >
                      <h4 class="grey--text font-weight-light">{{item.units}}</h4>
                    </v-flex>
                    <v-flex xs2 >
                      <h4 class="grey--text font-weight-light">{{item.perUnitAmount | currency}}</h4>
                    </v-flex>
                    <v-flex xs2 >
                      <h4 class="grey--text font-weight-bold">{{item.amount | currency}}</h4>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                </v-flex>
                <h3>Total: {{invoice.total | currency}}</h3>
              </v-layout>
              </v-card>
             

            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="selectOrgModal" persistent width="750px">
      <v-card flat color="white">
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Select an Organisation to Bill from:</h3>
        </v-toolbar>
        <v-card-text ma-1>
          <v-layout justify-center>
            <v-flex xs4 ma-1>
            <v-select :items="xeroOrganisations" item-text="orgData.name" item-value="orgData.organisationId" label="Organisation" return-object v-model="selectedOrganisation"></v-select>
          </v-flex>
          </v-layout>
          
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn v-if="selectedOrganisation" round color="primary" class="white--text" @click="prepInvoiceData()">Done</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "../services/Api";
import dateformat from "dateformat";
export default {
  data() {
    return {
      addPlanModal: false,
      addSubscription: false,
      allOrganisations: [],
      activeTabName: "subscribers",
      billingItem: {},
      billingModal: false,
      billableAmounts: [],
      customers: [],
      invoiceStatuses: ['DRAFT', 'SUBMITTED', 'AUTHORISED'],
      item: {},
      lineAmountTypes: ['Exclusive', 'Inclusive', 'NoTax'],
      plans: [],
      selectedBilling: [],
      selectedOrganisation: null,
      selectOrgModal: false,
      xeroAccounts: [],
      xeroAuth: null,
      xeroContacts: [],
      xeroOrganisations: [],
      xeroUrl: null,
      xeroTaxRates: [],
      planTypes: ['Active Service Accounts', 'Installed Locations', 'API', 'Application Page', 'Mobile App'],
      tabs: [
        { name: "subscribers", displayName: "Subscriptions" },
        { name: "plans", displayName: "Pricing Plans" },
        { name: "billing", displayName: "Billing" },
      ],
      billingHeaders: [
        // {
        //   text: "Action",
        //   align: "center",
        //   sortable: false,
        // },
        {
          text: "Customer",
          align: "center",
          value: "organisation.name",
        },
        {
          text: "Plans",
          align: "center",
          value: "name"
        },
        {
          text: "Amount",
          align: "center",
          value: "amount"
        },

      ],
      planHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Type",
          align: "center",
          sortable: false
        },
        {
          text: "Status",
          align: "center",
          value: "isActive",
        },

      ],
      subscriberHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Plan",
          align: "center",
          value: "gluePlan.name",
        },
        {
          text: "Start Date",
          align: "center",
          value: "startDate",
        },
        {
          text: "End Date",
          align: "center",
          value: "endDate",
        },
        {
          text: "Status",
          align: "center",
          value: "isActive",
        },
      ],
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getAllOrganisations();
      this.getBillableOrganisations();
      this.getGluePlans();
      this.getXeroLoginUrl();
    },
    getXeroLoginUrl(){
      // debugger
      Api().get('/xero/admin/authenticate').then(response=>{
        if(response.data.url){
        this.xeroUrl = response.data.url
        if(this.$route.query.code){
          this.getXeroTokens()
      }} else if(response.data.tokenSet){
        this.getXeroOrganisations()
      }
      })
    },
    getXeroTokens(){
      Api().get('/xero/admin/callback', {
        params:  this.$route.query
      }).then(response=>{
        if(response.data.tokenSet){
          this.xeroAuth = response.data.tokenSet
          this.getXeroOrganisations()
        }
      })
    },
    getBankTransactions(tenantId){
      Api().get('/xero/admin/bankTransactions/'+tenantId).then(response=>{
        console.log(response.data)
      })
    },
    getXeroTaxRates(tenantId){
      Api().get('/xero/admin/taxRates/'+tenantId).then(response=>{
        if(response.data.body.taxRates){
          this.xeroTaxRates = response.data.body.taxRates
        }
      })
    },
    getXeroContacts(tenantId){
      Api().get('/xero/admin/contacts/'+tenantId).then(response=>{
        if(response.data.body.contacts){
        this.xeroContacts = response.data.body.contacts
        }
        
      })
    },
    getXeroAccounts(tenantId){
      Api().get('/xero/admin/accounts/'+tenantId).then(response=>{
        if(response.data.body.accounts){
        this.xeroAccounts = response.data.body.accounts
        }
        
      })
    },
    prepInvoiceData(){
      this.getBankTransactions(this.selectedOrganisation.tenantId)
      this.getXeroTaxRates(this.selectedOrganisation.tenantId)
      this.getXeroContacts(this.selectedOrganisation.tenantId)
      this.getXeroAccounts(this.selectedOrganisation.tenantId)
      this.selectOrgModal = false
    },
    getBillingData(){
      Api().get('/admin/glueBillingRun').then(async response=>{
        let data = response.data
        console.log(data)
        let organisations = [
            ...new Set(
              response.data.map(
                item => item.organisationId
              )
            )
          ];
        // let organisations = 
        
        // response.data.map(x=>({organisationId: x.organisationId}))
        organisations= organisations.map(x=>({organisationId: x}))
        console.log(organisations)
        await organisations.map(async x=>{
          x.organisation = await data.find(y=>y.organisationId === x.organisationId).organisation
          x.plans = await data.filter(y=>y.organisation.id === x.organisationId)
          x.total = x.plans.reduce((a, b) => +a + +b.amount, 0)
        })
        this.billableAmounts = organisations
        // this.billableAmounts = response.data
      })
    },
    updateStatus(item){
        Api().put('/admin/updateSubscription/'+item.id, {isActive: !item.isActive})
        .then(response=>{
            let index = this.customers.indexOf(item)
            this.customers[index].isActive = !item.isActive
            this.key +=1
        })
    },
    updatePlanStatus(item){
    Api().put('/admin/updatePlan/'+item.id, {isActive: !item.isActive})
        .then(response=>{
            let index = this.plans.indexOf(item)
            this.plans[index].isActive = !item.isActive
            this.key +=1
        })
    },
    getXeroOrganisations(){
      Api().get('/xero/admin/getOrganisations').then(response=>{
        console.log(response.data)
        this.xeroOrganisations = response.data
        if(this.xeroOrganisations.length>1){
        this.selectOrgModal= true
        } else {
          this.selectedOrganisation = this.xeroOrganisations[0]
          this.prepInvoiceData()
        }
      })
    },
    addSubscriptionModal() {
      this.item = {
        modalType: "Add",
        organisationId: null,
        gluePlanId: null,
      };
      this.addSubscription = true;
    },
    editSubscription(item){
        this.item = item
        this.item.modalType = 'Edit'
        this.addSubscription = true;
    },
    addPlan(){
        this.item = {
            modalType: 'Add',
            isFlat: false,
            isBracket: false
        }
        this.addPlanModal = true;
    },
    editPlan(item){
      console.log(item)

        this.item = item
        this.item.modalType = 'Edit'
        this.item.glueBrackets.sort((a, b) =>
                    a.start >
                    b.start
                      ? 1
                      : b.start >
                        a.start
                      ? -1
                      : 0
                  );
        this.addPlanModal = true;
    },
    createNewPlan(item){
        Api().post('/admin/createPlan', item)
        .then(response=>{
            this.getGluePlans()
            this.addPlanModal = false
            this.item={}
        })
    },
    updatePlan(item){
      Api().put('/admin/updatePlan/'+item.id, item)
        .then(response=>{
            this.getGluePlans()
            this.addPlanModal = false
            this.item={}
        })
    },
    getAllOrganisations() {
      Api()
        .get("/organisation")
        .then((response) => {
          this.allOrganisations = response.data;
        });
    },
    getBillableOrganisations() {
      Api()
        .get("/admin/billableOrganisations")
        .then((response) => {
          this.customers = response.data;
          console.log(response.data);
        });
    },
    createSubscriberPlan(item) {
      Api()
        .post("/admin/createSubscription", item)
        .then((response) => {
          this.getBillableOrganisations();
          this.addSubscription = false;
          this.item = {};
        });
    },
    updateSubscriberPlan(item){
        item.startDate = new Date(item.startDate).toISOString()
              .substr(0, 10)
        item.endDate = new Date(item.endDate).toISOString()
              .substr(0, 10)

        Api().put('/admin/updateSubscription/'+item.id, item)
        .then(response=>{
            let find = this.customers.find(x=>x.id === item.id)
            let index = this.customers.indexOf(find)
            this.customers[index] = item
            this.key += 1
            this.addSubscription = false
            this.item = {}
        })
    },
    getGluePlans() {
      Api()
        .get("/admin/gluePlans")
        .then((response) => {
          this.plans = response.data;
        });
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    approveBilling(){
      this.billingModal=true
    },
    async sendInvoices(){
      console.log(this.billingItem)
      console.log(this.selectedBilling)
      let invoice = []
      await this.selectedBilling.forEach(async x=>{
        let obj = {
  type: "ACCREC",
  contact: { 
    contactID: x.plans[0].xeroContactId 
  },
  date: new Date().toISOString()
              .substr(0, 10),
  dueDate: this.billingItem.dueDate,
  dateString: new Date().toISOString()
              .substr(0, 10),
  dueDateString: this.billingItem.dueDate.toString(),
  lineAmountTypes: this.billingItem.lineAmountType,
  reference: this.billingItem.reference,
  status: this.billingItem.invoiceStatus,
  lineItems: []
}

for (let y=0; y<x.plans.length;y++){
  obj.lineItems.push({
      description: x.plans[y].name,
      quantity: x.plans[y].units,
      unitAmount: x.plans[y].perUnitAmount,
      accountCode: x.plans[y].xeroAccountCode,
      taxType: this.billingItem.taxRate
    })
}
invoice.push(obj)
      })
      console.log(invoice)
      Api().post('/xero/admin/invoices/'+this.selectedOrganisation.tenantId, invoice)
      .then(response=>{
        console.log(response.data)
        this.billingItem={}
        this.selectedBilling = []
        this.billingModal = false
      })
      
    }
  },
};
</script>